import React, { Component } from 'react';
import {ICard, ICardsRenderInfo} from "../../redux/types";
import { Group, Rect } from 'react-konva';
import Card from "../Card";

type Props = {
  index: number,
  cardParameters: ICardsRenderInfo,
  card: ICard,
  x: number,
  y: number,
}

class HomeCard extends Component<Props> {
  render() {
    const { card, x, y, cardParameters, index } = this.props;
    const { width, height, normalShadow, corner } = cardParameters;
    const shadow: number = index === 0 ? (normalShadow / 2) : 0;

    return (
      <Group
        listening={false}
        name={card.name}
        x={x}
        y={y}
      >
        <Rect
          perfectDrawEnabled={false}
          hitStrokeWidth={0}
          shadowForStrokeEnabled={false}
          visible={index === 0}
          fill="rgba(255,255,255,1)"
          shadowColor={'black'}
          shadowOpacity={0.5}
          shadowBlur={normalShadow}
          shadowOffset={{ x: shadow, y: shadow }}
          width={width}
          height={height}
          cornerRadius={corner}
        />
        <Card card={card} />
      </Group>
    );
  }
}

export default HomeCard;
